import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { faAngleDoubleDown, faAngleDown, faAngleUp, faHome } from '@fortawesome/free-solid-svg-icons'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import { faCogs } from '@fortawesome/free-solid-svg-icons'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { faLock } from '@fortawesome/free-solid-svg-icons'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { faPen } from '@fortawesome/free-solid-svg-icons'
import { faClock } from '@fortawesome/free-solid-svg-icons'

library.add(faShoppingCart)
library.add(faCogs)
library.add(faHome)
library.add(faChevronRight)
library.add(faChevronUp)
library.add(faChevronLeft)
library.add(faChevronDown)
library.add(faLock)
library.add(faInfoCircle)
library.add(faTimes)
library.add(faPlus)
library.add(faArrowRight)
library.add(faArrowLeft)
library.add(faCheck)
library.add(faEye)
library.add(faAngleDoubleDown)
library.add(faAngleDown)
library.add(faAngleUp)
library.add(faStar)
library.add(faPen)
library.add(faClock)

import vueAwesomeCountdown from 'vue-awesome-countdown'

Vue.use(vueAwesomeCountdown, 'vac')

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false

// Vue.prototype.$apiAdress = 'https://frippy-api.achrafammar.com'
Vue.prototype.$apiAdress = process.env.VUE_APP_API_URL
// Vue.prototype.$apiAdress = 'https://frippy-api.achrafammar.com'
Vue.config.performance = true
Vue.use(CoreuiVue)

// javascript import for when you're importing the css directly in your javascript
import "vue-navigation-bar/dist/vue-navigation-bar.css";

// import the library
import VueNavigationBar from "vue-navigation-bar";
Vue.component("vue-navigation-bar", VueNavigationBar);

import VueUploadComponent from 'vue-upload-component'
Vue.component('file-upload', VueUploadComponent);

let moment = require('vue-moment');
Vue.use(moment);

// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading, {
  color: '#ef86c1',
  loader: 'spinner',
  width: 64,
  height: 64,
  backgroundColor: '#ffffff',
  opacity: 0.5,
  zIndex: 999,
});

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

import VueConfirmDialog from 'vue-confirm-dialog'
Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

import OtpInput from "@bachdgvn/vue-otp-input";
Vue.component("v-otp-input", OtpInput);

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

Vue.component('VuePhoneNumberInput', VuePhoneNumberInput);

import vmodal from 'vue-js-modal'
Vue.use(vmodal)

import VModal from 'vue-js-modal'
Vue.use(VModal)

//Override Style Colors
let bodyStyles = document.body.style;

bodyStyles.setProperty('--primary', '#ef86c1');
bodyStyles.setProperty('--primary-dark', '#ff2fa4');
bodyStyles.setProperty('--secondary', '#fff');

// import OneSignalVue from 'onesignal-vue'

// Vue.use(OneSignalVue);
// import OneSignal from 'onesignal-cordova-plugin';

// // Call this function when your app starts
// function OneSignalInit(){
//   // NOTE: Update the setAppId value below with your OneSignal AppId.
//   alert(0)
//   OneSignal.setAppId("035cc6c1-2747-4935-b6e2-063fcc7ca288");
// }
// OneSignalInit();
// localStorage.setItem('shop_user','{"id":8,"name":"Walid","phone":"55741943","email":"driverwalid6@gmail.com","age":"20-29","gender":"M","created_at":"2021-09-07T17:28:06.000000Z","updated_at":"2021-09-07T17:28:06.000000Z","deleted_at":null}')
// localStorage.setItem('shop_token',"eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiMDYyMWI4YTcwZWQxNGY0OWZhOWY2ODc1MTZmMDk5ODRhNTczNjc3M2Q4OGQ2YmVmMjYwY2I5M2JlOWFmMmUzZjczMmFjMTkwMmZhMjA4OWMiLCJpYXQiOjE2MzIzMDMwNzgsIm5iZiI6MTYzMjMwMzA3OCwiZXhwIjoxNjYzODM5MDc4LCJzdWIiOiI4Iiwic2NvcGVzIjpbXX0.Ht3XSNQ2hlYI6BeOLOvJBmE274-2DkwQNjAEAn-HzaeynSfPY-V38PslCENGj85Q0yFF-zzEjEvYnTZRCLbNDjPbCromPrOpXceh7LvMIcOPf1BDjBwFHC0Sv0UBJWBsTCBEZP-kRBWjxDUqiiLHpKOcFfQSXuaQzZqjZBiYvYypqwX6UnPwRfuWwGDGrMoXOuja_Bi7rxlin1w1Rxg2quMHQWFysVEvW3l6zdXl2_lc0J1WulaZtDjyMfZ20dYuPQt6tFlBXbuYf7oZwI0QbK3TjXw-XEhEYhBbMLz5eYYKPga_uvAmk8f1cJTAE8YHp0C1xN54ZODaCGKhFLb_x4j9r5gH1ARBkLQxaDa3f1RSO6U-I8ZvB9-9YiQ1AmhF2OHQy2AHaepuN7k7OYVfyCryB89TpPYUQlncIck3r3VP2z3d8dnCQf1Oj7KMYlSPse2Er9jAQh8LFrTiXo_gJXbe-zNRFu6WhDrSpzr21VrZDCnHPHV_m6w2eh_unnaI1HJzCVZ1srGYk_yY5eVP9c9NCrXCoxfwIXy2K35Suq-afV40ML6hquj2JJzaDNXsDVA-1VetznQCc_ZLwXdot4NE7l_3KdG2A2MUvchjoHDo-vrcc1gVSYqXvgdPpq0w0A3JOiHSbE6Wg4UnAp0vx66uGE9ygHP10QxOM0PVTYs")
import i18n from "./i18n/i18n.js";
if (!localStorage.getItem("Language")) {
  localStorage.setItem("Language", "en");
}
new Vue({
  el: '#app',
  router,
  store,  
  icons,
  template: '<App/>',
  components: {
    App
  },
  i18n
  // beforeMount() {
  //   this.$OneSignal.init({ appId: "035cc6c1-2747-4935-b6e2-063fcc7ca288" });
  // }
}).$mount('#app')
